import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';
// Modal séparé
import FeeTypeModal from "./partials/FeeTypeModal";

import {
    getFeeTypes as onGetFeeTypes,
    addNewFeeType as onAddNewFeeType,
    updateFeeType as onUpdateFeeType,
    deleteFeeType as onDeleteFeeType,

    //getDepartments as onGetDepartments,
    //getTrainingTypes as onGetTrainingTypes,
    getPrestations as onGetPrestations,
    getBranches as onGetBranches,
    getStudyLevels as onGetStudyLevels,
    resetFeeTypeActionSuccess as OnResetFeeTypeActionSuccess


} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const FeeType = () => {

    //meta title
    document.title = "Types de frais | CinzanEdu";

    const dispatch = useDispatch();
    
    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [feeType, setFeeType] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);
    const [loadingState, setLoadingState] = useState(true);
    



    // Selector FeeType
     const FeeTypeProperties = createSelector(
        (state) => state.feeTypeReducer, 
        (feeTypeReducer) => ({
            feeTypes: feeTypeReducer.feeTypes,
            loading: feeTypeReducer.loading,
            success: feeTypeReducer.success
        })
    );

    const {feeTypes, loading, success} = useSelector(FeeTypeProperties);

    const [isLoading, setLoading] = useState(loading)


    // Selector prestation
     const PrestationProperties = createSelector(
        (state) => state.prestationReducer, 
        (prestationReducer) => ({
            prestations: prestationReducer.prestations,
            loading: prestationReducer.loading
        })
    );
    const {prestations} = useSelector(PrestationProperties);

    // Selector Branch
     const BranchProperties = createSelector(
        (state) => state.branchReducer, 
        (branchReducer) => ({
            branches: branchReducer.branches,
            loading: branchReducer.loading
        })
    );
    const {branches} = useSelector(BranchProperties);

    // Selector Study level
     const StudyLevelProperties = createSelector(
        (state) => state.studyLevelReducer, 
        (studyLevelReducer) => ({
            studyLevels: studyLevelReducer.studyLevels,
            loading: studyLevelReducer.loading
        })
    );
    const {studyLevels} = useSelector(StudyLevelProperties);


     // Chargement initial des données
    useEffect(() => {
        if (!feeTypes.length) dispatch(onGetFeeTypes());
        if (!prestations.length) dispatch(onGetPrestations());
        if (!branches.length) dispatch(onGetBranches());
        if (!studyLevels.length) dispatch(onGetStudyLevels());
        setLoadingState(loading);
    }, [dispatch, feeTypes.length, prestations.length,branches.length,studyLevels.length,   loading]);


    // Ferme le modal en cas de success
    useEffect(() => {
        
        if (success && modal) {
            toggle();
            setFeeType(null);
            dispatch(OnResetFeeTypeActionSuccess()); // action qui remet à false
        }
    }, [success, modal, dispatch]);

   
    // Toggle modal
      const toggle = () => {
        setModal(!modal);
        if (modal) setFeeType(null);
      };
    
      // Créer nouvelle structure
      const onClickNewFeeType = () => {
        setIsEdit(false);
        setFeeType(null);
        toggle();
      };
    
      // Edit structure
      const handleFeeTypeClick = (feeType) => {
        setFeeType(feeType);
        setIsEdit(true);
        toggle();
        dispatch(OnResetFeeTypeActionSuccess()); // reset pour l’édition
      };
    
      // Delete structure
      const onClickDelete = (feeType) => {
        setFeeType(feeType);
        setDeleteModal(true);
      };
      const handleDeleteFeeType = () => {
        if (feeType?.id) {
          dispatch(onDeleteFeeType(feeType));
          setDeleteModal(false);
        }
      };

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Prestation",
                accessorKey: "prestation.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Nationalité",
                accessorKey: "nationality",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Source de financement",
                accessorKey: "funding_source",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Filière",
                accessorKey: "branch.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            {
                header: "Niveau d'étude",
                accessorKey: "study_level.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Montant",
                accessorKey: "amount",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleFeeTypeClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteFeeType}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Types de frais" breadcrumbItem="Liste des type de frais" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="flex-shrink-0">
                                                    <Link to="#!" onClick={onClickNewFeeType} className="btn btn-primary me-1">Ajouter un type de frais</Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={feeTypes || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                   

                   {/* Modal séparé */}
                    <FeeTypeModal
        
                        modal={modal}
                        toggle={toggle}
                        isEdit={isEdit}
                        feeType={feeType}
                        prestations={prestations}
                        branches={branches}
                        studyLevels={studyLevels}
                        onSubmit={(payload) => {
                        if (isEdit) {
                            dispatch(onUpdateFeeType(payload));
                        } else {
                            dispatch(onAddNewFeeType(payload));
                        }
                        //toggle(); // 🔹 Fermeture automatique après succès
                        }}
                    />

                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}


export default FeeType;